import {useEffect, useState} from 'react';
import {Table} from 'react-bootstrap';
import {DateUtils, DisplayUtils, OrderDetail, StringUtils} from "shared-lib";

interface ViewModel extends OrderDetail {
    profit: string;
    holdingTimeDiff: number;
    holdingTime: string;
    profitValue: number;
    enterTime: number;
    exitTime: number;
}

export function AlgoRobotResultComponent(props: {
    orders: OrderDetail[]
}): React.ReactElement {

    const [orders, setOrders] = useState([] as ViewModel[]);
    const [sortConfig, setSortConfig] = useState({
        columnName: 'enterTime',
        direction: -1,
        valueType: 'string'
    });

    useEffect(() => {
        setOrders(props.orders.map(order => {
            let enterAlertTime, exitAlertTime, profitValue, profitPercentage, profit, holdingTime,
                holdingTimeDiff, enterTime, exitTime;
            exitAlertTime = profit = '-';

            let position = order.position?.replace('_', ' ');
            enterAlertTime = DateUtils.formatedDatetime(order.enterAlertTime);
            enterTime = DateUtils.parseDateTime(order.enterAlertTime).getTime();
            if (order.exitPrice) {
                exitTime = DateUtils.parseDateTime(order.exitAlertTime).getTime();
                exitAlertTime = DateUtils.formatedDatetime(order.exitAlertTime);
                holdingTime = DateUtils.from(order.exitAlertTime, order.enterAlertTime);
                holdingTimeDiff = exitTime - enterTime;
                profitValue = order.exitPrice - order.enterPrice;
                profitPercentage = profitValue / order.enterPrice * 100;
                profit = `${profitPercentage.toFixed(2)}%`;
            } else {
                holdingTime = DateUtils.fromNow(order.enterAlertTime);
                holdingTimeDiff = (new Date()).getTime() - enterTime;
            }
            return {
                ...order,
                profit,
                position,
                holdingTime,
                exitAlertTime,
                enterAlertTime,
                holdingTimeDiff,
                profitValue,
                enterTime,
                exitTime
            }
        }));
    }, [props])

    const getIconByDirection = (columnName: string) => {
        return sortConfig.columnName === columnName &&
            <i className={`bi bi-arrow-${sortConfig.direction > 0 ? 'up' : 'down'}-short`}></i>
    }

    const sortByStringValue = (columnName: string, direction: number) => {
        return orders.sort((order1, order2) => direction * StringUtils.compare(order1[columnName], order2[columnName]));
    }

    const sortBySNumberValue = (columnName: string, direction: number) => {
        return orders.sort((order1, order2) => direction * (order1[columnName] - order2[columnName]));
    }

    const updateSortConfig = (columnName: string, valueType: string) => {
        let direction = 1;

        if (sortConfig.columnName === columnName) {
            direction = sortConfig.direction * -1;
        }
        setSortConfig({columnName, direction, valueType});
    }


    const
        generateRows = () => {
            let myOrders = [];

            if (sortConfig.valueType === 'string') {
                myOrders = sortByStringValue(sortConfig.columnName, sortConfig.direction);
            } else if (sortConfig.valueType === 'number') {
                myOrders = sortBySNumberValue(sortConfig.columnName, sortConfig.direction);
            }

            return myOrders.map(order => {
                return <tr>
                    <td>{DisplayUtils.displayRawValue(order.code)}</td>
                    <td>{DisplayUtils.displayRawValue(order.position)}</td>
                    <td>{DisplayUtils.displayFormattedNumberValue(order.enterPrice)}</td>
                    <td>{DisplayUtils.displayFormattedNumberValue(order.size)}</td>
                    <td>{DisplayUtils.displayTextValue(order.enterAlertTime)}</td>
                    <td>{DisplayUtils.displayRawValue(order.holdingTime)}</td>
                    <td>{DisplayUtils.displayRawValue(order.exitAlertTime)}</td>
                    <td>{DisplayUtils.displayFormattedNumberValue(order.exitPrice)}</td>
                    <td className={`${order.profitValue > 0 ? 'text-success' : 'text-danger'}`}>{
                        DisplayUtils.displayRawValue(order.profit)
                    }</td>
                </tr>
            });
        };


    return (
        <div>
            <Table striped hover>
                <thead>
                <tr>
                    <th>SEMBOL KODU</th>
                    <th>SİNYAL</th>
                    <th className="point" role="button"
                        onClick={() => updateSortConfig('enterPrice', 'number')}
                    >GİRİŞ FİYATI
                        {getIconByDirection('enterPrice')}
                    </th>
                    <th className="point" role="button"
                        onClick={() => updateSortConfig('size', 'number')}
                    >
                        ADET
                        {getIconByDirection('size')}
                    </th>
                    <th className="point" role="button"
                        onClick={() => updateSortConfig('enterTime', 'string')}
                    >
                        GİRİŞ TARİHİ
                        {getIconByDirection('enterTime')}
                    </th>
                    <th className="point" role="button"
                        onClick={() => updateSortConfig('holdingTimeDiff', 'string')}
                    >
                        TAŞIMA SÜRESİ
                        {getIconByDirection('holdingTimeDiff')}</th>
                    <th className="point" role="button"
                        onClick={() => updateSortConfig('exitTime', 'string')}
                    >
                        ÇIKIŞ TARİHİ
                        {getIconByDirection('exitTime')}
                    </th>
                    <th className="point" role="button"
                        onClick={() => updateSortConfig('exitPrice', 'number')}>
                        ÇIKIŞ FİYATI
                        {getIconByDirection('exitPrice')}
                    </th>
                    <th className="point" role="button"
                        onClick={() => updateSortConfig('profitValue', 'number')}
                    >
                        GETİRİ YÜZDESİ (%)
                        {getIconByDirection('profitValue')}
                    </th>
                </tr>
                </thead>
                <tbody>
                {generateRows()}
                </tbody>
            </Table>
        </div>
    );

}
